// extracted by mini-css-extract-plugin
export default {"submitButton":"BvfNfzC6uvotEi0wqxad","warningText":"FpBuyBkbKJyUp8vt_nUX","inactiveUsersRow":"MUA1rrmUXJ8LU8oxazoX","orphanedRow":"nOh9zfT7lkgfrH1xrNkz"};